import { UseFormReturn } from "react-hook-form";
import NumberEditor from "./Global/Editors/NumberEditor";
import TextEditor from "./Global/Editors/TextEditor";
import { useGlobalData } from "./GlobalDataProvider";
import SelectEditor from "./Global/Editors/SelectEditor";
import { DTOBuilding, DTOModule } from "../types/building";
import { IAbonnemang, IModuleByggnadsdata } from "../types/ModuleDatas";
import { nameof } from "./Global/Utils";
import { MapTooltip } from "../types/globalData";
import { useEffect, useRef, useState } from "react";
import { get, post } from "../modules/server";
import { IHousingStock } from "../types/customer";
import { numFrmt0Dec } from "../modules/common";
import { logDebugSilently } from "../modules/logger";

interface IProps {
  formHook: UseFormReturn;
  isDisabled?: boolean;
  onPriceChange?: (price: number) => void;
  hook?: { getPrice?: () => number };
  currentHousingStock?: IHousingStock;
}

const Abonnemang = ({ formHook, isDisabled, onPriceChange, hook, currentHousingStock }: IProps) => {
  const noOfBuildings = formHook.watch("noOfBuildings");
  const totalSurfaceArea = formHook.watch("totalSurfaceArea");
  const [price, setPrice] = useState(0);
  const tmrRef = useRef<NodeJS.Timeout | undefined>(undefined);
  if (hook) hook.getPrice = () => price;
  useEffect(() => {
    const fetchPrice = async () => {
      if (!noOfBuildings || !totalSurfaceArea) return;
      logDebugSilently("fetchPrice : " + new Date());
      const response = await post("GetPrice", { noOfBuildings, totalSurfaceArea });
      if (response.success) {
        setPrice(response.price);
        if (onPriceChange) {
          onPriceChange(response.price);
        }
      }
    };
    // Short delay to avoid too many requests
    if (tmrRef.current) clearTimeout(tmrRef.current);
    tmrRef.current = setTimeout(fetchPrice, 400);
  }, [noOfBuildings, totalSurfaceArea]);

  const numberFormatter = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 });
  const pricePerYear: string | undefined = price ? numberFormatter.format(price) : undefined;
  const pricePerMonth: string | undefined = price ? numberFormatter.format(price / 12) : undefined;
  return (
    <>
      <div className="row overflow-hidden gy-0  align-items-end">
        <div className="col-lg-12">
          <NumberEditor
            label="Byggnadsmängd (st)"
            showWhenIsDisabled={true}
            fieldName={nameof<IAbonnemang>("noOfBuildings")}
            formHook={formHook}
            options={{
              required: "Byggnadsmängd måste anges!",
            }}
            isDisabled={isDisabled}
            min={1}
            tooltipCallBack={currentHousingStock ? () => `Faktisk byggnadsmängd: ${currentHousingStock.noOfBuildings}` : undefined}
          />
        </div>
      </div>
      <div className="row overflow-hidden gy-0  align-items-end">
        <div className="col-lg-12">
          <NumberEditor
            label="Total bruksarea eller A-temp yta (kvm)"
            fieldName={nameof<IAbonnemang>("totalSurfaceArea")}
            formHook={formHook}
            options={{
              required: "Total bruksarea måste anges!",
            }}
            isDisabled={isDisabled}
            showWhenIsDisabled={true}
            min={1}
            step={1}
            tooltipCallBack={currentHousingStock ? () => `Faktisk total bruksarea: ${numFrmt0Dec.format(currentHousingStock.totalSurfaceArea)} kvm` : undefined}
          />
        </div>
      </div>
      <div className="row overflow-hidden gy-0  align-items-end">
        <div className="col-lg-12">
          <div className="input-group">
            <label className="form-label w-100">
              <span>Kostnad QWTOOL-abonnemang kr/år</span>
              <input className="form-control" type="text" disabled={true} value={pricePerYear} />
            </label>
          </div>
        </div>
      </div>
      <div className="row overflow-hidden gy-0  align-items-end">
        <div className="col-lg-12">
          <div className="input-group">
            <label className="form-label w-100">
              <span>Kostnad QWTOOL-abonnemang kr/månad</span>
              <input className="form-control" type="text" disabled={true} value={pricePerMonth} />
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Abonnemang;
